// @flow
import * as React from 'react';
import { Box, Button } from 'grommet';
import RangeSelect from 'esm-web-pro/containers/pages/network/objects/point12/poplayer12/connect/RangeSelect';
import ActionButtons from 'esm-web-pro/components/forms/ActionButtons';
import sidePanelMessages from 'esm-web-pro/messages/sidePanelMessages';
import ApiClient from 'speed-js-core/src/api/ApiClient';
import type { BreakConnectionPayload } from 'esm-web-pro/api/resources/OpticalODFPortResource';
import { connectAPI } from 'speed-js-react';
import { injectIntl, IntlShape } from 'react-intl';
import Spinner from 'esm-web-pro/components/forms/Spinner';


type Props = {
    port: Object,
    object: { fiber: number } | { port: number },
    onClose: Function,
    intl: IntlShape,
    breakConnection: (id: string, data: BreakConnectionPayload) => Promise<Object>,
    onSave: Function,
    onClose: Function,
    calculateMaxRange: Function,
};

const DisconnectPortForm = (props: Props) => {
    const {
        port, onClose, intl: { formatMessage }, breakConnection, onSave,
        calculateMaxRange, object,
    } = props;

    const [submitting, setSubmitting] = React.useState(false);
    const [range, setRange] = React.useState(1);
    const [rangeError, setRangeError] = React.useState(null);

    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        setSubmitting(true);
        if (range) {
            breakConnection(port.uuid, {
                range,
                ...object,
                sfp_port_number:
                    Object.prototype.hasOwnProperty.call(port, 'sfp_port_number') && port.sfp_port_number,
            })
                .then(() => {
                    setSubmitting(false);
                    onSave();
                });
        }
    };

    return (
        <>
            <Spinner loading={submitting} />
            <Box height="100%">
                <Box
                    direction="row"
                    align="center"
                    height="100%"
                    overflow="auto"
                    style={{ position: 'unset' }}
                >
                    <Box alignSelf="stretch" flex justify="between">
                        <Box flex={{ shrink: 0 }} pad={{ bottom: 'small' }}>
                            <Box height="12px" flex={{ shrink: 0 }} />
                            <Box pad={{ horizontal: 'medium' }}>
                                <RangeSelect
                                    calculateMaxRange={calculateMaxRange}
                                    onChange={setRange}
                                    value={range}
                                    error={rangeError}
                                    onError={setRangeError}
                                />
                            </Box>
                        </Box>
                        {(range && !rangeError) ? (
                            <ActionButtons
                                onClose={handleClose}
                                onSave={handleSave}
                            />
                        ) : (
                            <ActionButtons onClose={handleClose} onSave={false} />
                        )}
                    </Box>
                </Box>
            </Box>
        </>
    );
};


export const apiCallbacks = (apiClient: ApiClient, props: Props) => ({
    breakConnection: {
        send: (id: string, data: BreakConnectionPayload) => apiClient.resources[props.port.type]
            .breakConnection(id, data),
    },
});

export default connectAPI(apiCallbacks)(injectIntl(DisconnectPortForm));
